<!--
 * @Descripttion: 静态卡片
 * @Author: zenghua.wang
 * @Date: 2021-09-26 16:03:56
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-28 16:51:55
-->
<template>
  <div
    :class="setClass()"
    :style="styleSize"
    v-custom-loading="loading"
    :custom-loading-text="component.loadingText"
    :custom-loading-spinner="component.loadingSpinner"
    :custom-loading-background="component.loadingBackground"
  >
    <ul :class="setClass('wrapper')">
      <li
        :class="setClass('panel')"
        :style="styleCard"
        v-for="(item,index) in cardList"
        :key="index"
      >
        <div
          :class="setClass('body', option.shadow)"
          :style="styleOpcity(item, option.shadow)"
        >
          <div
            :class="setClass('picture')"
            v-if="item.showPicture"
          >
            <img
              :src="`${FDFS_WEB_SERVER_URL + item.picture}`"
              :style="styleImage"
              draggable="false"
            />
          </div>
          <div
            :class="setClass('content')"
            :style="styleContent"
          >
            <template v-if="!option.reverse">
              <div
                :class="setClass('content__value')"
                @click="setLink(item.url, json)"
              >
                <span :style="styleText(item)">{{item.value}}</span>
                <b :style="styleSuffix(item)">{{item.suffixText}}</b>
              </div>
              <div
                :class="setClass('content__title')"
                :style="styleTitle(item)"
              >
                <i
                  :style="styleIcon(item)"
                  v-if="item.showIcon"
                ></i>
                <span>{{item.name}}</span>
              </div>
            </template>
            <template v-else>
              <div
                :class="setClass('content__title')"
                :style="styleTitle(item)"
              >
                <i
                  :style="styleIcon(item)"
                  v-if="item.showIcon"
                ></i>
                <span>{{item.name}}</span>
              </div>
              <div
                :class="setClass('content__value')"
                @click="setLink(item.url, json)"
              >
                <span :style="styleText(item)">{{item.value}}</span>
                <b :style="styleSuffix(item)">{{item.suffixText}}</b>
              </div>
            </template>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import bem from '@/dragComponents/mixins/bem'
import customLoading from '@/dragComponents/directive/loading'
import card from '@/dragComponents/mixins/card'
import { deepClone, isEmpty, setPx } from '@/dragComponents/utils'
import {
  component,
  FDFS_WEB_SERVER_URL
} from '@/dragComponents/model/default.js'
import mock from '@/dragComponents/model/mock.js'

export default {
  name: 'drag-card',
  mixins: [bem, card],
  components: {},
  directives: { customLoading },
  data() {
    return {
      FDFS_WEB_SERVER_URL: FDFS_WEB_SERVER_URL,
      component: component,
      json: {}
    }
  },
  computed: {
    styleCard() {
      return {
        width: 100 / this.option.col + '%',
        padding: setPx(this.option.margin)
      }
    },
    styleOpcity() {
      return (item, shadow) => {
        return {
          padding: setPx(this.option.padding),
          borderWidth: shadow === 'hover' ? '1px' : 0,
          backgroundColor: item.opcity
            ? 'rgba(255,255,255,0)'
            : item.backgroundColor
        }
      }
    },
    styleText() {
      return (item) => {
        return {
          fontSize: setPx(item.textFontSize),
          fontWeight: item.textFontWeight,
          color: item.textColor
        }
      }
    },
    styleSuffix() {
      return (item) => {
        return {
          color: item.textColor
        }
      }
    },
    styleTitle() {
      return (item) => {
        return {
          fontSize: setPx(item.titleFontSize),
          fontWeight: item.titleFontWeight,
          color: item.titleColor
        }
      }
    },
    styleIcon() {
      return (item) => {
        let { iconSize, iconRadius, iconColor, titleColor } = item
        return {
          display: 'inline-block',
          width: setPx(iconSize || 12),
          height: setPx(iconSize || 12),
          marginRight: setPx(8),
          borderRadius: setPx(iconRadius || 2),
          backgroundColor: iconColor || titleColor
        }
      }
    }
  },
  methods: {
    init() {
      if (isEmpty(this.apiId)) {
        this.cardList = mock.card.column
      }
    },
    setOption() {
      this.cardList = []
      let list = deepClone(this.option.column)
      let data = Array.isArray(this.dataList) ? this.dataList[0] : this.dataList
      this.json = data
      list.forEach((item) => {
        item.value = data[item.prop]
        item.name = item.title || data[item.prop]
      })
      this.cardList = list
    }
  }
}
</script>
<style lang='scss' scoped>
@import '@/dragComponents/styles/card/index.scss';
</style>
